'use client';

import { UBLogo } from '@/components/Logo';
import UBTrustBoxContainer from '@/components/UBTrustPilot';
import { cn } from '@/lib/utils';
import { Separator } from '@music-vine/cadence/ui';
import { BrandStatementCards } from './BrandStatementCards';
import { GotQuestions } from './GotQuestions';
import { PageLinks } from './PageLinks';
import { UppbeatLogoMission } from './UppbeatLogoMission';
import FooterBottom from './FooterBottom';
interface FooterProps {
  distractionFree?: boolean;
}
const Footer = ({
  distractionFree = false
}: FooterProps) => <footer className={cn('flex flex-col bg-gray-50 p-6 md:p-0 dark:bg-gray-900')} data-sentry-component="Footer" data-sentry-source-file="index.tsx">
    <BrandStatementCards className={distractionFree ? 'pb-6 md:py-10' : 'mb-16 md:mb-4 md:pt-8 lg:mb-7 lg:pt-10'} data-sentry-element="BrandStatementCards" data-sentry-source-file="index.tsx" />

    {/* Hide this content when footer is set to "mimimal" */}
    {!distractionFree && <div className="flex flex-col">
        <div className="mt-10 mb-8 flex flex-col items-start md:m-0 md:items-stretch md:px-container md:py-4">
          <Separator className="hidden md:block" />
          <div className="flex flex-row items-center justify-between md:my-8">
            <UBTrustBoxContainer />
            <div className="hidden items-center justify-center lg:flex">
              <p className="text:lg font-heading font-semibold text-gray-950 lg:text-xl 2xl:text-2xl dark:text-white">
                Freedom to <span className="text-pink-500">create</span>
              </p>
            </div>
          </div>
          <Separator className="hidden md:block" />
        </div>

        {/* `contents` below md, so the logo can sit above the TrustPilot block */}
        <div className="contents md:mb-4 md:grid md:grid-cols-4 md:gap-2 md:gap-y-12 md:p-container xl:grid-cols-6 xl:grid-rows-1">
          <div className={cn('-order-1 flex flex-col justify-start',
      // Mobile
      'md:container md:order-none md:col-span-4 md:flex-row md:items-center md:gap-12',
      // Tablet
      'xl:col-span-2 xl:flex-col xl:items-start xl:justify-center xl:gap-8 xl:pr-10' // Desktop
      )}>
            <UBLogo className="h-12 md:h-auto" />
            <UppbeatLogoMission />
          </div>
          <PageLinks />
        </div>

        <div className="my-8 md:hidden">
          <GotQuestions />
        </div>
      </div>}

    <FooterBottom hideSocials={distractionFree} data-sentry-element="FooterBottom" data-sentry-source-file="index.tsx" />
  </footer>;
export default Footer;